import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import PropTypes from 'prop-types';
import { Form, Icon, Input, Button } from 'antd';
import displayServerErrors from '../../../utilities/form/display_server_errors';
import { createResetPasswordToken } from './mutations/createResetPasswordToken';
import ResetPasswordEmailSent from "./email_sent";
import './form.css';

const FormItem = Form.Item;

class ResetPasswordRequestForm extends Component {
  static propTypes = {
    mutate: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  get mutationParams() {
    return {
      variables: {
        input: {
          ...this.props.form.getFieldsValue()
        }
      }
    }
  }

  async submitData() {
    try {
      this.setState({ loading: true });
      await this.props.mutate(this.mutationParams);
      this.setState({ success: true, email: this.props.form.getFieldValue('email') });
    } catch(response) {
      displayServerErrors(this.props.form, response, { 'base': 'email' });
    } finally {
      this.setState({ loading: false });
    }
  }

  onSubmit(event) {
    event.preventDefault();

    this.props.form.validateFields((error, _values) => {
      if (!error) {
        this.submitData();
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    if (this.state.success)
      return <ResetPasswordEmailSent email={ this.state.email }/>;
    else
      return (
        <Form onSubmit={this.onSubmit.bind(this)} className="troubles-logging-in-form">
          <h1 className="troubles-logging-in-form__header">Troubles logging in?</h1>
          <FormItem>
            <h1>{this.props.token}</h1>
            <h2 className="troubles-logging-in-form__header-2">I forgot my password</h2>
            <p>To reset your password enter the email address you use to log in. The password reset link will be sent to you</p>
          </FormItem>
          <FormItem>
            {getFieldDecorator('email', {
              rules: [
                { required: true, message: 'Please enter an email' }
              ],
            })(
              <Input prefix={<Icon type="mail" style={{ fontSize: 13 }} />} placeholder="Email" />
            )}
          </FormItem>
          <FormItem>
            <Button type="primary" htmlType="submit" className="troubles-logging-in-form__troubles-logging-in-button" loading={this.state.loading}>
              <b>RESET PASSWORD</b>
            </Button>
          </FormItem>
          <FormItem>
            <h2 className="troubles-logging-in-form__header-2">I have other problems logging in</h2>
            <p>In order to access your account please contact <br/> your Pastor / Evangelist</p>
          </FormItem>
        </Form>
      );
  }
}

export default Form.create()(graphql(createResetPasswordToken)(ResetPasswordRequestForm));


// WEBPACK FOOTER //
// ./src/components/pages/reset_password_request/form.js